import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { adminClicked } from '../actions/admin';
import MenuIcon from './MenuIcon';
import './Header.css';

const mapStateToProps = state => ({
  adminMode: state.admin.adminMode,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ adminClicked }, dispatch);
}

const Admin = ({ clickFunc }) => (
  <div id="admin-button" onClick={clickFunc}>
    Admin
  </div>
);

const MobileView = ({ scrollTo, close }) => (
  <div className="mobile-menu">
    <div
      onClick={() => {
        scrollTo(2);
        close();
      }}
    >
      Itinerary
    </div>
    <div
      onClick={() => {
        scrollTo(3);
        close();
      }}
    >
      RSVP
    </div>
    <div
      onClick={() => {
        scrollTo(4);
        close();
      }}
    >
      Travel
    </div>
    <div
      onClick={() => {
        scrollTo(5);
        close();
      }}
    >
      Registry
    </div>
    {/* <div
      onClick={() => {
        scrollTo(5);
        close();
      }}
    >
      Suggestions
    </div> */}
    <div
      onClick={() => {
        scrollTo(6);
        close();
      }}
    >
      Photos
    </div>
  </div>
);

const FullView = ({ adminMode, scrollTo, adminClicked }) => (
  <div className="full-menu">
    <div onClick={() => scrollTo(2)}>Itinerary</div>
    <div onClick={() => scrollTo(3)}>RSVP</div>
    <div onClick={() => scrollTo(4)}>Travel</div>
    <div onClick={() => scrollTo(5)}>Registry</div>
    {/* <div onClick={() => scrollTo(5)}>Suggestions</div> */}
    <div onClick={() => scrollTo(6)}>Photos</div>
    {adminMode && <Admin clickFunc={adminClicked} />}
  </div>
);

class Header extends Component {
  state = {
    menuOpen: false,
  };

  _scrollTo(sectionId) {
    const element = document.querySelector(`#section-${sectionId}`);
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  _menuButtonClicked(e) {
    const elements = document.querySelectorAll('.menu-bar');

    elements.forEach(x => x.classList.toggle('change'));
    this.setState({
      menuOpen: !this.state.menuOpen,
    });
  }

  render() {
    return (
      <div>
        <MenuIcon onClick={this._menuButtonClicked.bind(this)} />
        <header>
          <FullView
            adminMode={this.props.adminMode}
            scrollTo={this._scrollTo.bind(this)}
            adminClicked={this.props.adminClicked.bind(this)}
          />
          {this.state.menuOpen && (
            <div
              className="menu-full-page-click"
              onClick={this._menuButtonClicked.bind(this)}
            />
          )}
        </header>
        {this.state.menuOpen && (
          <MobileView
            scrollTo={this._scrollTo.bind(this)}
            close={this._menuButtonClicked.bind(this)}
          />
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js